<template>
  <section>
    <search1 back="/home" :searchStatus="false" v-if="userDetail.accessgroup['name'] == 'Supervisor'"></search1>
    <STHeader v-else></STHeader>

    <section class="padding-footer">
      <b-container>
        <div class="util-tabs">
          <div
            class="util-tab"
            v-for="(item, i) in tabs"
            :class="tab == i ? 'active' : ''"
            :key="i"
            @click="setTab(i)"
          >
            <img :src="getImgUrl(item.image)" />
            <span>{{ item.title }}</span>
          </div>
        </div>
        <div v-if="tab === 0">
          <utilities-listrik></utilities-listrik>
        </div>
        <div v-if="tab === 1">
          <utilities-gas></utilities-gas>
        </div>
        <div v-if="tab === 2">
          <utilities-air></utilities-air>
        </div>
        <div v-if="tab === 3">
          <utilities-kue></utilities-kue>
        </div>
      </b-container>
    </section>
    <!-- <MenuFooter /> -->
  </section>
</template>
<script lang="js">
import Vue from "vue";
import Search1 from "@/components/Search1.vue";
import { Component } from "vue-property-decorator";
import MenuFooter from "@/views/layout/footer/MenuFooter.vue";
import UtilitiesListrik from "@/views/pages/Utilities/Modules/Listrik/Utilities-Listrik.vue";
import UtilitiesGas from "@/views/pages/Utilities/Modules/Gas/Utilities-Gas.vue";
import UtilitiesAir from "@/views/pages/Utilities/Modules/Air/Utilities-Air.vue";
import UtilitiesKue from "@/views/pages/Utilities/Modules/Kue/Utilities-Kue.vue";
import STHeader from "@/views/layout/header/Header.vue";

import { UserModule } from "@/store/modules/user";

@Component({
    components: {
        MenuFooter,
        Search1,
        UtilitiesListrik,
        UtilitiesGas,
        UtilitiesAir,
        UtilitiesKue,
        STHeader
    },
})
export default class Utilities extends Vue {
    mounted(){
      
      this.tab = Number(this.$route.query?.tab ?? "0")
    }
    tabs = [
        {title:"Listrik",image:"util-tab-1.svg"},
        {title:"Gas",image:"util-tab-2.svg"},
        {title:"Air",image:"util-tab-3.svg"},
        {title:"Kue",image:"util-tab-4.svg"},
    ];
    tab = null;
    setTab(tab){
      this.$router.push({ query: {tab:tab} });
      this.tab = tab
    }
    userDetail = UserModule.userDetail;
    getImgUrl(pet) {
        var images = require.context('@/assets/img', false, /\.svg$/);
        return images('./' + pet)
    }
}
</script>
